import React from "react";
import TitoloPagina from "../utils/TitoloPagina";
import { motion } from "framer-motion";

import Hero from "../components/Hero";
import Layout from "../components/ui/Layout";
import Reviews from "../components/Reviews";
import Structures from "../components/Structures";
import Activities from "../components/Activities";
import FAQ from "../components/FAQ";
import Contact from "../features/Contact";
import KeyFeatures from "../components/KeyFeatures";
import { DURATA, VISTA } from "../utils/motionPresets";
import DatiStrutturati from "../utils/DatiStrutturati";
import { ldStrutture } from "../data/datiStrutturati";

// Solo dissolvenza: l'unico movimento della home sono le due card struttura.
const fadeInUp = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  transition: { duration: DURATA.blocco, ease: "easeOut" },
  viewport: VISTA,
};

export default function HomePage() {
  return (
    <>
      <TitoloPagina chiave="home" />
      <DatiStrutturati id="strutture" dati={ldStrutture()} />
      <section className="relative md:h-[85vh] z-20">
        <Hero />
      </section>
      <section className="w-full bg-lux-bg z-10">
        <Layout>
          <motion.div {...fadeInUp}><Structures /></motion.div>
          <div className="max-w-5xl mx-auto px-6">
            <hr className="border-0 border-t-2 border-[#2e2921]" />
          </div>
          <motion.div {...fadeInUp}><KeyFeatures /></motion.div>
          <motion.div {...fadeInUp}><Reviews /></motion.div>
          <motion.div {...fadeInUp}><Activities /></motion.div>
          <div className="max-w-5xl mx-auto px-6">
            <hr className="border-0 border-t-2 border-[#2e2921]" />
          </div>
          <FAQ />

          <motion.div {...fadeInUp}><Contact /></motion.div>
        </Layout>
      </section>
    </>
  );
}
